import React, { useEffect, useState } from "react";
import ProductModalWithButton from "./ProductModalWithButton";

function TechRateDetail({
  deductible,
  onTotalChange = () => {},
  products,
  rate,
  selectedProgram,
  setSelectedProgram,
  term,
}) {
  const [total, setTotal] = useState(0);
  const [techActive, setTechActive] = useState(false);
  const isSelectedProgram = selectedProgram?.id === rate?.id;

  const getProductDescription = (productName) => {
    const matchedSubtype = products[0].subtypes.find(
      (subtype) => subtype.name === productName
    );
    return matchedSubtype?.coverage_description !== null
      ? matchedSubtype.coverage_description
      : matchedSubtype.description;
  };

  const getProductName = (currentProduct) => {
    return currentProduct.name.replace(/Component : /g, "");
  };

  const handleRadioChange = (e) => {
    let newRate = rate;
    if (!e.target.checked) {
      newRate = null;
    }
    setSelectedProgram(newRate);
  };

  const handleSwitchChange = (e) => {
    const productNodes = document.querySelectorAll(".tech");
    const techPricing = document.getElementById("techPricing");

    if (e.target.checked) {
      productNodes.forEach((node) => node.classList.add("active"));
      techPricing.classList.remove("d-none");
      setTechActive(true);
    } else {
      productNodes.forEach((node) => node.classList.remove("active"));
      techPricing.classList.add("d-none");
      setTechActive(false);
    }

    updateTotal(rate);
  };

  const updateTotal = (currentRate) => {
    let currentTotal = currentRate.retail_price || rate.cost;
    currentRate.products.forEach((product) => {
      const input = document.getElementById(`flexSwitchCheck${product.id}`);
      if (product.required === false && input.checked === true) {
        const priceIncrease = product.retail_price || product.cost;
        currentTotal += priceIncrease;
      }
    });

    setTotal(currentTotal);
  };

  useEffect(() => {
    if (rate) {
      updateTotal(rate);
    }
    if (techActive) {
      const productNodes = document.querySelectorAll(".tech");
      const techPricing = document.getElementById("techPricing");
      productNodes?.forEach((node) => node.classList.add("active"));
      techPricing?.classList.remove("d-none");
    }
  });

  useEffect(() => {
    if (rate) {
      onTotalChange(rate.id, total);
    }
  }, [rate, total, onTotalChange]);

  return (
    <div
      className={`rate-detail ${
        !isSelectedProgram && selectedProgram !== null ? "disabled" : ""
      }`}
    >
      {rate?.products.map((product) => (
        <div key={product.id} id={product.id}>
          <div className={`product lh-1 p-2 mb-3 tech w-100`}>
            {getProductName(product)}
            <ProductModalWithButton
              productId={product.id}
              productDescription={getProductDescription(
                getProductName(product)
              )}
              productName={getProductName(product)}
            />
          </div>
        </div>
      ))}
      {rate ? (
        <div className="row justify-content-end">
          <div className={`pricing col d-none`} id="techPricing">
            <input
              className="form-check-input me-2"
              id={`rate-${rate.id}`}
              type="checkbox"
              onClick={handleRadioChange}
              onChange={() => {}}
              checked={isSelectedProgram ? "checked" : ""}
            />
            <label htmlFor={`rate-${rate.id}`}>
              Total: ${total.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </label>
          </div>
          <div className="col-3 me-4">
            <div className="form-check form-switch form-check-reverse mb-3">
              <input
                className="form-check-input fs-4"
                type="checkbox"
                role="switch"
                id="flexSwitchCheck"
                onChange={handleSwitchChange}
                checked={techActive}
              />
            </div>
          </div>
        </div>
      ) : (
        <p>
          Not Available for {term} months with ${deductible} deductible
        </p>
      )}
    </div>
  );
}

export default TechRateDetail;
